import { toast } from "sonner";
import {
  isClerkNetworkError,
  SIGN_OUT_FAILED_COPY,
  SIGN_OUT_FAILED_TITLE_COPY,
} from "@fomofi/shared";

/**
 * FP-174: offline, sign-out now fails instead of pretending (it used to look done and
 * the session came back on reconnect). Every sign-out control says so, in one sentence.
 */
export function reportSignOutFailure(err: unknown): void {
  toast.error(
    isClerkNetworkError(err)
      ? `${SIGN_OUT_FAILED_TITLE_COPY}. ${SIGN_OUT_FAILED_COPY}`
      : "We couldn't sign you out. Please try again.",
  );
}
